import {
  Country,
  IClient,
  IClientData,
  IClientDetail,
  IClientDetailData,
  IClientExtradata,
  IThirdcode,
  Thirdcode,
  IClientSubclient,
  ICountry,
  ClientSubclient,
  IClientSyncResponse,
} from "@/entities";
import { ILimit, Limit } from "@/entities/limit";

export class Client implements IClient {
  readonly id?: number;
  readonly oidSol?: string;
  readonly label?: string;
  readonly codeSol?: string;
  readonly idSmartcash?: string;
  readonly uniqueCode?: string;
  readonly description?: string;
  readonly active?: boolean;
  readonly country?: ICountry;
  readonly extradata?: IClientExtradata[];
  readonly thirdcodes?: IThirdcode[];
  readonly limits?: ILimit[];

  constructor(data: IClientData) {
    this.id = data.id;
    this.oidSol = data.oidSol;
    this.label = data.label;
    this.codeSol = data.codeSol;
    this.idSmartcash = data.idSmartcash;
    this.uniqueCode = data.uniqueCode;
    this.description = data.description;
    this.active = data.active;
    this.extradata = data.extradata?.map((clienExtradata) => new Extradata(clienExtradata));
    this.thirdcodes = data.thirdcodes?.map((thirdcode) => new Thirdcode(thirdcode));
    this.limits = data.limits?.map((limit) => new Limit(limit));

    if (data.country) {
      this.country = new Country(data.country);
    }
  }
}

export class ClientDetail extends Client implements IClientDetail {
  readonly subclients: IClientSubclient[];

  constructor(data: IClientDetailData) {
    super(data);

    this.subclients = data.subclients?.map((subclient) => new ClientSubclient(subclient));
  }
}

export class Extradata extends Client implements IClientExtradata {
  readonly name?: string;
  readonly label?: string;
  readonly type?: string;
  readonly attr1?: string;
  readonly required?: boolean;

  constructor(data: IClientExtradata) {
    super(data);

    this.name = data.name;
    this.label = data.label;
    this.type = data.type;
    this.attr1 = data.attr1;
    this.required = data.required;
  }
}

export class ClientSyncResponse implements IClientSyncResponse {
  success: boolean;
  data: IClientDetailData | null;
  message?: string;

  constructor(success: boolean, data: IClientDetailData | null, message?: string) {
    this.success = success;
    this.data = data;
    this.message = message;
  }
}
